import React, { Component } from 'react';
import { _delete, get, patch, postWithHeaders, postWithHeadersResponse } from '../../../server/actions'
import { currency_symbol } from '../../../server/constants'
import Modal from 'react-modal'
import PropTypes from "prop-types";
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import ReactTable from 'react-table'
import '../../../../src/assets/css/react-table.css'
import { BeatLoader } from 'react-spinners';
import 'react-tabs/style/react-tabs.css';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import NotificationSystem from 'react-notification-system';
import {
    _addNotification, _addNotificationError, _addNotificationWarning,
    formatDate, allowNumericWithdecimal, convertTwoDecimalPoint, getGradeIndexValue, getGradeIndex, allowNumberWithDecimalNegative, getSchoolGrades
} from '../../../server/util';
import $ from "jquery";
import Toggle from 'react-toggle';
import EmailSelect from './EmailSelect';
import CustomSubmit from '../../Misc/customSubmit';
var _ = require('lodash');
var converter = require('number-to-words');
const CheckboxTable = checkboxHOC(ReactTable);
const modalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '60%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial',
        WebkitBoxShadow: '0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)',
        boxShadow: '0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)'
    }
};
const adjustPayModalStyles = {
    content: {
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial',
        WebkitBoxShadow: '0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)',
        boxShadow: '0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)'
    }
};
const alertStyle = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '40%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial',
        WebkitBoxShadow: '0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)',
        boxShadow: '0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)'
    }
}
const adjustPaymentObjConst = {
    studentRecId: 0,
    studentName: '',
    balAmount: 0,
    adjustAmount: 0,
    reason: "",
    payType: ''
}
let gradeList = [];
class ManagePayments extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            students: [],
            studentsCount: 0,
            action: 'all',
            data: [],
            columns: [],
            selection: [],
            selectAll: false,
            selectedRows: [],
            currentPage: 0,
            currentGrade: 0,
            schoolYear: sessionStorage.getItem('schoolYearValue'),
            gradeIndex: 0,
            payModalIsOpen: false,
            refundModalIsOpen: false,
            transferModalIsOpen: false,
            isEqualDistSelected: false,
            isTransEqualDistSelected: false,
            alertModalIsOpen: false,
            alertRefundModalIsOpen: false,
            primaryStudentData: {},
            //studentWiseTransactions:[],
            payModalObject: {
                mealSchoolId: 0,
                transactionType: '',
                paymentType: '',
                transactionDescription: '',
                checkNumb: '',
                totalTransactionAmount: 0.00,
                studentWiseTransactions: [] //{ "studentRecId":375,"name":"","balAmt":0.00,"transactionAmount":200},                                 
            },
            showEmailSelect: false,
            emailList: [],
            refundModalObject: {
                reasonForRefund: '',
                studentWiseRefundTransactions: []
            },
            payTransferModalObject: {
                mealSchoolId: 0,
                //transactionType:'',
                //paymentType:'',
                transactionDescription: '',
                //checkNumb:'',
                totalTransactionAmount: 0.00,
                studentWiseTransactions: [] //{ "studentRecId":375,"name":"","balAmt":0.00,"transactionAmount":200},                                 
            },
            adjustPayment: {
                adjustPayModalIsOpen: false,
                isDebit: false,
                adjustPaymentObj: JSON.parse(JSON.stringify(adjustPaymentObjConst))
            }
        }
        this.getDataByGrade = this.getDataByGrade.bind();
        this.previousPage = this.previousPage.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.closePaymentModel = this.closePaymentModel.bind(this);
        this.closePaymentAdjustModel = this.closePaymentAdjustModel.bind(this);
        this.computAmount = this.computAmount.bind(this);
        this.equalDistribute = this.equalDistribute.bind(this);
        this.equalTransferDistribute = this.equalTransferDistribute.bind(this);
    }
    componentWillMount = () => {
        Modal.setAppElement('body');
        let filter = this.context.router.route.match.params.filter || 'all';
        let gradeName = this.context.router.route.match.params.grade || '0';
        let grade = this.getTabIndex(gradeName);//getGradeIndexValue(gradeName==0?'all':gradeName);
        //let grade=gradeName==0?0:getGradeIndex((this.props.grades||[]),gradeName)//getGradeIndexValue(gradeName);
        let schoolYear = this.context.router.route.match.params.schoolYear || sessionStorage.getItem('schoolYearValue')
        this.setState({
            action: filter,
            // tabIndex: (typeof grade === "number" ? converter.toWords(grade) : grade),
            schoolYear: schoolYear,
            gradeIndex: grade,
            currentGrade: gradeName
        }, this.getDataByGrade(gradeName, filter, schoolYear));


    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;

    }
    getTabIndex = (grade) => {
        const gradeList = getSchoolGrades();
        const idx = gradeList.findIndex(item => item.value === grade);
        return (idx < 0 ? 0 : idx)
    }
    previousPage = () => {
        if (this.state.currentPage !== 0)
            this.setState({ currentPage: this.state.currentPage - 1 })
    }
    nextPage = () => {
        if ((this.state.currentPage + 1) * 20 < this.state.students.length)
            this.setState({ currentPage: this.state.currentPage + 1 })
    }
    getDataByGrade = (gradeName, action, schoolYear) => {
        let teachers = [];
        let studentsByGrade = [];
        this.setState({ loading: true });
        let schoolId = sessionStorage.getItem('SchoolId');
        (get('/studentUsers/search/findByIsActiveAndMealSchoolSchoolIdAndSchoolYear?isActive=true&schoolId=' + schoolId + '&schoolYear=' + schoolYear + '&access_token='))
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
                console.log("allStudentData", this.state.allStudentData);
                console.log('data', data);
                const stData = data['_embedded']['studentUsers'];
                let activeStData = stData //_.filter(stData, function(o) { return o.register; });
                this.setState({ studentsCount: activeStData.length });
                if ((gradeName || '0') == '0') {
                    return activeStData.map(item => {
                        let _id = item.studentId;
                        return {
                            _id,
                            ...item
                        };
                    });
                }
                else {
                    activeStData.map(item => { //pushes all students for grade selected into an array
                        let _gradeName = item.gradeName;
                        if (_gradeName === gradeName) {
                            studentsByGrade.push(item);
                        }
                    });
                    return studentsByGrade.map(item => {
                        let _id = item.studentId;
                        return {
                            _id,
                            ...item
                        };
                    });
                }
                // return studentData;
            }).then(data => {
                /* You can do all the function calls from in here in the same .then(data => {}) call aboves */
                // console.log("Students by grade " + JSON.stringify(studentsByGrade));
                //this.setState({ studentsCount: studentsByGrade.length });
                let columns = this.getColumns(data);

                let s = document.getElementById('search').value;
                let filteredData = [] //this.state.students.slice();        
                //let filter = document.getElementById('selector').querySelectorAll(".active")[0].getAttribute("name") || '';
                switch (action) {
                    case 'negativeBal':
                        data.map(item => {
                            item.accBalance < 0 ? filteredData.push(item) : '';
                        });
                        break;
                    default:
                        filteredData = data;
                        break;
                }
                let searchedSchool = [];
                if (s.length > 0) {
                    filteredData.forEach(obj => {
                        if (obj.firstName != null && (obj.firstName.toLowerCase() + ' ' + obj.lastName.toLowerCase()).startsWith(s.toLowerCase())) {
                            searchedSchool.push(obj);
                        } else if (obj.lastName != null && (obj.lastName.toLowerCase()).startsWith(s.toLowerCase())) {
                            searchedSchool.push(obj);
                        } else if (obj.mobileNum != null && (obj.mobileNum.replace(/[()\-" ]+/g, '').toLowerCase()).startsWith(s.toLowerCase())) {
                            searchedSchool.push(obj);
                        } else if (obj.parentuser.userName != null && (obj.parentuser.userName.toLowerCase()).startsWith(s.toLowerCase())) {
                            searchedSchool.push(obj);
                        } else if (obj.pin != null && (obj.pin.toLowerCase()).startsWith(s.toLowerCase())) {
                            searchedSchool.push(obj);
                        }
                    });
                }
                this.setState({
                    students: data,
                    data: searchedSchool.length == 0 ? filteredData : searchedSchool,
                    columns: columns,
                    loading: false,
                    studentCount: data.length
                });
            }).catch(
                (error) => {
                    this.setState({ loading: false })
                    console.log('Get School data response', error)
                }
            );
    }
    getColumns = (data) => {
        let columns = [];
        let header = ['First Name', 'Last Name', 'MOBILE NO', 'PARENT EMAILID', 'A/C BALANCE', 'ACTIONS'];
        if (data.length === 0) {
            header.map(key =>
                columns.push({ Header: key }));
        }
        else {
            columns.push({
                accessor: 'firstName',
                Header: 'First Name',
                Cell: props => <span>{props.original.firstName}</span>,
                style: { textAlign: 'center' }
            });
            columns.push({
                accessor: 'firstName',
                Header: 'Last Name',
                Cell: props => <span>{props.original.lastName}</span>,
                style: { textAlign: 'center' }
            });
            columns.push({
                accessor: 'parentuser.userName',
                Header: 'PARENT EMAILID',
                style: { textAlign: 'center' }
            });
            columns.push({
                accessor: 'mobileNo', // formatted mobile num for display
                Header: 'PARENT MOBILENO',
                style: { textAlign: 'center' }
            });
            columns.push({
                accessor: 'pin', // formatted mobile num for display
                Header: 'Pin',
                style: { textAlign: 'center' }
            });
            columns.push({
                accessor: 'accBalance', // formatted mobile num for display
                Header: 'A/C BALANCE',
                style: { textAlign: 'center' },
                Cell: ({ row }) => (
                    <span style={{ textAlign: 'center' }}>
                        {currency_symbol() + ' ' + convertTwoDecimalPoint(row._original.accBalance)} </span>),
                Footer: <div style={{ textAlign: "center" }}>
                    {currency_symbol() + ' ' + (_.sum(_.map(data, d => d.accBalance))).toFixed(2)}
                </div>
            });

            columns.push({
                id: 'actionButton',
                accessor: "studentId",
                Header: 'ACTIONS',
                style: { textAlign: 'center' }, // className: "actions text-center"
                Cell: ({ row }) => (<div>
                    <a title="Add Payment" onClick={() => this.addPayment('single', row._original)}>
                        {row._original.register ? <i className="fa fa-money tbl-rounded-icon bg-color-4 fa-icon" /> : <i className="fa fa fa-money tbl-rounded-icon bg-color-2 fa-icon" />}</a>
                    <a title="Transfer" onClick={() => this.moneyTransfer('single', row._original)}>
                        <i className="fa fa-exchange tbl-rounded-icon bg-color-2 fa-icon" /></a>
                    {/* <a title="Refund" onClick={() => this.moneyRefund('single', row._original)}>
                         <i className="fa fa-undo tbl-rounded-icon bg-color-3 fa-icon"/></a>    */}
                    <a title="Adjust Payment (Debit/Credit)" onClick={() => {
                        let _adjustPayment = this.state.adjustPayment;
                        _adjustPayment.adjustPayModalIsOpen = true;
                        let _adjustPaymentObj = _adjustPayment.adjustPaymentObj;
                        _adjustPaymentObj.studentRecId = row._original._links.self.href.split("/").pop()
                        _adjustPaymentObj.studentName = row._original.lastName + ', ' + row._original.firstName;
                        _adjustPaymentObj.balAmount = row._original.accBalance;
                        //_adjustPaymentObj.payType="AdjustmentDR";
                        _adjustPayment.adjustPaymentObj = _adjustPaymentObj;
                        this.setState({ adjustPayment: _adjustPayment })
                    }}><b><i className="fa tbl-rounded-icon fa-icon bg-color-6">+/-</i></b></a>
                </div>),
            });

        }
        return columns;
    }
    toggleSelection = (key, shift, row) => {
        //alert('selection')
        // alert(key)
        let selection = [...this.state.selection];
        let selectedRows = [...this.state.selectedRows]
        const keyIndex = selection.indexOf(key);
        // check to see if the key exists
        if (keyIndex >= 0) {
            // it does exist so we will remove it using destructing
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
            selectedRows = [
                ...selectedRows.slice(0, keyIndex),
                ...selectedRows.slice(keyIndex + 1)
            ]
        } else {
            // it does not exist so add it
            selection.push(key);
            selectedRows.push(row);
        }
        // update the state
        this.setState({ selection, selectedRows });
        this.setState({ selectAll: false });
    };
    toggleAll = () => {
        //alert('toggleAll')
        const selectAll = this.state.selectAll ? false : true;
        const selection = [];
        let selectedRows = []
        if (selectAll) {
            // we need to get at the internals of ReactTable
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            // the 'sortedData' property contains the currently accessible records based on the filter and sort
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            //this.setState({studentCount: currentRecords.length});
            // we just push all the IDs onto the selection array
            //console.log(JSON.stringify(currentRecords,null,2))
            currentRecords.forEach(item => {
                selection.push(item._original._id);
                selectedRows.push(item._original)
            });
        }
        this.setState({ selectAll, selection, selectedRows });
    };
    isSelected = key => {
        return this.state.selection.includes(key);
    };
    filterSchool = () => {
        let s = document.getElementById('search').value;
        //alert(s)
        let filteredData = [] //this.state.students.slice();        
        let filter = document.getElementById('selector').querySelectorAll(".active")[0].getAttribute("name") || '';
        switch (filter) {
            case 'negativeBal':
                this.state.students.map(item => {
                    item.accBalance < 0 ? filteredData.push(item) : '';
                });
                break;
            default:
                filteredData = this.state.students;
                break;
        }
        let searchedSchool = [];

        if (s.length > 0) {

            filteredData.forEach(obj => {
                if (obj.firstName != null && (obj.firstName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.lastName != null && (obj.lastName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.mobileNum != null && (obj.mobileNum.replace(/[()\-" ]+/g, '').toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.parentuser.userName != null && (obj.parentuser.userName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.pin != null && (obj.pin.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                }
            });
            //.replace(/[()\-" ]+/g, '')
            this.setState({ data: searchedSchool })
        }
        else {
            this.setState({ data: searchedSchool.length == 0 ? filteredData : searchedSchool, columns: this.getColumns(searchedSchool.length == 0 ? filteredData : searchedSchool) })
        }
        this.forceUpdate();
    };
    addPayment = (action, row) => {
        let payObj = this.state.payModalObject;
        payObj.mealSchoolId = sessionStorage.getItem('SchoolId');
        payObj.transactionType = 'Deposit';
        payObj.paymentType = 'Cash';
        payObj.transactionDescription = '';
        payObj.checkNumb = '';
        payObj.totalTransactionAmount = 0.00;
        if (action === 'single') {
            payObj.studentWiseTransactions = [
                {
                    studentRecId: row._links.self.href.split("/").pop(),
                    name: row.firstName + ' ' + row.lastName,
                    balAmt: row.accBalance,
                    transactionAmount: 0.00
                }
            ] //{ "studentRecId":375,"name":"","balAmt":0.00,"transactionAmount":200},                 

        } else {
            let selectedRows = this.state.selectedRows
            if (selectedRows.length > 0) {
                selectedRows.map((row) => {
                    payObj.studentWiseTransactions.push(
                        {
                            studentRecId: row._links.self.href.split("/").pop(),
                            name: row.firstName + ' ' + row.lastName,
                            balAmt: row.accBalance,
                            transactionAmount: 0.00
                        }
                    )
                });
            }
            else {
                return
            }
        }
        this.setState({ payModalIsOpen: true, payModalObject: payObj });
    }
    closeEmailSelect = () => {
        this.setState({ showEmailSelect: false, emailList: [] })
    }
    openEmailSelect = (e, callback) => {
        let _payObj = Object.assign({}, this.state.payModalObject);
        let _studentWiseTransactions = []
        _payObj.studentWiseTransactions.map(stud => {
            if ((stud.transactionAmount || 0) != 0) {
                _studentWiseTransactions.push(stud);
            }
        })
        _payObj.studentWiseTransactions = _studentWiseTransactions;
        if ((_payObj.totalTransactionAmount || 0) == 0.00) {
            _addNotificationError("Please provide transaction amount.", this);
            callback(true);
            return false;
        }
        if (_payObj.totalTransactionAmount != this.computAmount()) {
            _addNotificationError("Total transaction amount & sum of individual students amount not matched.", this);
            callback(true);
            return false;
        }
        if (_payObj.paymentType === "Check") {
            if (_payObj.checkNumb === '') {
                _addNotificationError("Please provide check no.", this);
                callback(true);
                return false;
            }
        }
        if (_payObj.paymentType === "CreditCard") {
            if (_payObj.checkNumb === '') {
                _addNotificationError("Please provide transaction number.", this);
                callback(true);
                return false;
            }
        }
        /* let _emailIds=[];
        _payObj.studentWiseTransactions.forEach(stu=>{
           let idx=this.state.students.findIndex(item=>{
               return item._links.self.href.split("/").pop()==stu.studentRecId
           })
           if(idx>=0){
            _emailIds.push(this.state.students[idx].parentuser.userName);
            if((this.state.students[idx].parentuser.parentAltEmail||'').trim().length>0){
                _emailIds.push(this.state.students[idx].parentuser.parentAltEmail);
            }
           }
        });
        const uniqueSet = new Set(_emailIds);
        const uniqueEmails = ([...uniqueSet]).map(id=>{
            return {email:id,selected:false}
        })
        if(uniqueEmails.length==1){
            uniqueEmails[0].selected=true
            this.setState({emailList:uniqueEmails},
                this.paymentSubmit(e)) 
        }else{
            if(uniqueEmails.length>1){
                this.setState({showEmailSelect:true,emailList:uniqueEmails})
            }
        } */
        this.paymentSubmit(e, callback);

    }
    moneyTransfer = (action, row) => {
        let payTransferObj = this.state.payTransferModalObject;
        payTransferObj.studentWiseTransactions = []
        payTransferObj.mealSchoolId = sessionStorage.getItem('SchoolId');
        payTransferObj.totalTransactionAmount = 0.00;
        get('/studentUsers/search/findByEmailAndYearAndSchool?username=' + row.parentuser.userName + '&schoolYear=' + sessionStorage.getItem('schoolYearValue') + '&mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&access_token=').then((response) => {
            this.setState({ loading: true })
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then((data) => {
            this.setState({ loading: false })
            let studentsList = data._embedded.studentUsers || {};
            //let student_List = [];            
            console.log(JSON.stringify(studentsList, null, 2))
            studentsList.forEach(student => {
                if (student.studentId != row.studentId) {
                    //student_List.push(student);
                    payTransferObj.studentWiseTransactions.push(
                        {
                            studentRecId: student._links.self.href.split("/").pop(),
                            name: student.firstName + ' ' + student.lastName,
                            balAmt: student.accBalance,
                            transactionAmount: 0.00
                        }
                    )
                }
            });

            if (payTransferObj.studentWiseTransactions.length > 0) {
                this.setState({ transferModalIsOpen: true, primaryStudentData: row, payTransferModalObject: payTransferObj });

            } else {
                this.setState({ alertModalIsOpen: true, primaryStudentData: {} });
            }

        }).catch(
            (error) => {
                this.setState({ loading: false })
                console.log('Parent dashboard error', error);
            }
        )
    }
    moneyRefund = (action, row) => {
        let refundObj = this.state.refundModalObject;
        refundObj.mealSchoolId = sessionStorage.getItem('SchoolId');
        if (action === 'single') {
            refundObj.studentWiseRefundTransactions = [
                {
                    studentRecId: row._links.self.href.split("/").pop(),
                    name: row.firstName + ' ' + row.lastName,
                    balAmt: row.accBalance,
                    transactionAmount: 0.00
                }
            ]

        }
        if (row.accBalance <= 0) {
            this.setState({ alertRefundModalIsOpen: true });
        } else {
            this.setState({ refundModalIsOpen: true, refundModalObject: refundObj });
        }

    }
    closeRefundModel = () => {
        let refundObj = this.state.refundModalObject;
        refundObj = {};
        refundObj.reasonForRefund = '';
        refundObj.studentWiseRefundTransactions = [];
        this.setState({ refundModalIsOpen: false, refundModalObject: refundObj });
        this.getDataByGrade(typeof this.state.currentGrade === "number" && this.state.currentGrade != 0 ? converter.toWords(this.state.currentGrade) : this.state.currentGrade, this.state.action, this.state.schoolYear);
    }
    closePaymentModel = () => {
        let payObj = this.state.payModalObject;
        payObj = {};
        payObj.studentWiseTransactions = []
        this.setState({ payModalIsOpen: false, payModalObject: payObj, isEqualDistSelected: false, showEmailSelect: false, emailList: [] });
        this.getDataByGrade(typeof this.state.currentGrade === "number" && this.state.currentGrade != 0 ? converter.toWords(this.state.currentGrade) : this.state.currentGrade, this.state.action, this.state.schoolYear);
    }
    closePaymentTrnaferModel = () => {
        //this.setState({transferModalIsOpen:false});
        let payObj = this.state.payTransferModalObject;
        payObj = {};
        payObj.studentWiseTransactions = []
        this.setState({ transferModalIsOpen: false, payTransferModalObject: payObj, isTransEqualDistSelected: false });
        this.getDataByGrade(typeof this.state.currentGrade === "number" && this.state.currentGrade != 0 ? converter.toWords(this.state.currentGrade) : this.state.currentGrade, this.state.action, this.state.schoolYear);
    }
    closePaymentAdjustModel = () => {
        let _adjustPayment = this.state.adjustPayment;
        _adjustPayment.adjustPayModalIsOpen = false;
        _adjustPayment.adjustPaymentObj = JSON.parse(JSON.stringify(adjustPaymentObjConst))
        this.setState({ adjustPayment: _adjustPayment })
    }
    computAmount() {
        let payObj = this.state.payModalObject;
        let _computeAmount = 0.0;
        payObj.studentWiseTransactions.map((s) => {
            _computeAmount = _computeAmount + parseFloat(s.transactionAmount)
        });
        return parseFloat(_computeAmount.toFixed(2));
    }
    computTransferAmount() {
        let payObj = this.state.payTransferModalObject;
        let _computeAmount = 0.0;
        payObj.studentWiseTransactions.map((s) => {
            _computeAmount = _computeAmount + parseFloat(s.transactionAmount)
        });
        return parseFloat(_computeAmount.toFixed(2));
    }
    equalDistribute = (amount) => {
        let payObj = this.state.payModalObject;
        if (amount != 0) {
            let distAmt = parseFloat((amount / payObj.studentWiseTransactions.length).toFixed(2))
            let balAmt = amount - (distAmt * payObj.studentWiseTransactions.length);
            payObj.studentWiseTransactions.map((stud) => {
                stud.transactionAmount = parseFloat((amount / payObj.studentWiseTransactions.length).toFixed(2))
            })
            payObj.studentWiseTransactions[payObj.studentWiseTransactions.length - 1].transactionAmount = (distAmt + balAmt).toFixed(2);
        }
        else {
            payObj.studentWiseTransactions.map((stud) => {
                stud.transactionAmount = 0
            })
        }
        this.setState({ payModalObject: payObj })

    }
    equalTransferDistribute = (amount) => {
        let payObj = this.state.payTransferModalObject;
        if (amount != 0) {
            let distAmt = parseFloat((amount / payObj.studentWiseTransactions.length).toFixed(2))
            let balAmt = amount - (distAmt * payObj.studentWiseTransactions.length);
            payObj.studentWiseTransactions.map((stud) => {
                stud.transactionAmount = parseFloat((amount / payObj.studentWiseTransactions.length).toFixed(2))
            })
            payObj.studentWiseTransactions[payObj.studentWiseTransactions.length - 1].transactionAmount = (distAmt + balAmt).toFixed(2);
        }
        else {
            payObj.studentWiseTransactions.map((stud) => {
                stud.transactionAmount = 0
            })
        }
        this.setState({ payTransferModalObject: payObj })

    }
    paymentSubmit = (e, callback) => {
        e.preventDefault();
        let payObj = Object.assign({}, this.state.payModalObject);
        let _studentWiseTransactions = []
        payObj.studentWiseTransactions.map(stud => {
            if ((stud.transactionAmount || 0) != 0) {
                _studentWiseTransactions.push(stud);
            }
        })
        payObj.studentWiseTransactions = _studentWiseTransactions;
        if ((payObj.totalTransactionAmount || 0) == 0.00) {
            _addNotificationError("Please provide transation amount.", this);
            callback(true);
            return false;
        }
        if (payObj.totalTransactionAmount != this.computAmount()) {
            _addNotificationError("Total transaction amount & sum of individual students amount not matched.", this);
            callback(true);
            return false;
        }
        if (payObj.paymentType === "Check") {
            if (payObj.checkNumb === '') {
                _addNotificationError("Please provide check no.", this);
                return false;
            }
        }
        if (payObj.paymentType === "CreditCard") {
            if (payObj.checkNumb === '') {
                _addNotificationError("Please provide transaction number.", this);
                return false;
            }
        }
        let emailList = []
        this.state.emailList.forEach(email => {
            if (email.selected) {
                emailList.push(email.email)
            }
        });
        payObj.parentUserEmails = emailList.join(',');
        let headers = {
            'Content-Type': 'application/json'
        };
        postWithHeaders("/transactions/depositAmtThruOffline?studentRecId=" + payObj.studentWiseTransactions[0].studentRecId + "&mealSchoolId=" + sessionStorage.getItem('SchoolId') + "&access_token=", JSON.stringify(payObj), headers).then((response) => {
            if (response.status === 200) {
                this.setState({ loading: false })
                _addNotification('Lunch Balance added successfully.', this);
                this.closePaymentModel();
                callback(true);
            } else if (!response.ok) {
                throw Error(response.statusText);
            }
            //alert(response.status)
        }).catch(
            (error) => {
                _addNotificationError('Failed to add payment ! Try again.', this);
                console.log('Send Notification Error', error);
                this.closePaymentModel();
                callback(true);
            }
        );
    }

    paymentTransferSubmit = (e, callback) => {
        e.preventDefault();
        let payObj = Object.assign({}, this.state.payTransferModalObject);
        let _studentWiseTransactions = []
        this.state.payTransferModalObject.studentWiseTransactions.map(obj => {
            if (parseFloat(((obj.transactionAmount || '') == '') ? 0 : obj.transactionAmount) > 0.00) {
                _studentWiseTransactions.push(obj);
            }
        })
        payObj.studentWiseTransactions = _studentWiseTransactions;
        if ((payObj.totalTransactionAmount || 0) == 0.00) {
            _addNotificationError("Please provide transaction amount.", this);
            callback(true);
            return false;
        }
        let payTransferObj = {
            sourceTransferTransaction: {
                mealSchoolId: sessionStorage.getItem('SchoolId'),
                transactionDescription: "Amount transfer to the sibling",
                totalTransactionAmount: this.state.primaryStudentData.accBalance,
                studentWiseTransactions: [
                    {
                        studentRecId: this.state.primaryStudentData._links.self.href.split("/").pop(),
                        transactionAmount: payObj.totalTransactionAmount
                    }
                ]
            },
            tragetTransferTransaction: payObj
        }
        let headers = {
            'Content-Type': 'application/json'
        };
        postWithHeadersResponse("/transactions/transferBalance?access_token=", JSON.stringify(payTransferObj), headers).then((response) => {
            if (response.statusCode === 200) {
                this.setState({ loading: false })
                _addNotification(response.statusMessage, this);
                this.closePaymentTrnaferModel();
                callback(true);
            } else if (!response.ok) {
                throw Error(response.errorMessage);
            }
            //alert(response.status)
        }).catch(
            (error) => {
                _addNotificationError(error.message, this);
                console.log('Send Notification Error', error);
                callback(true);
                this.closePaymentTrnaferModel();
            }
        );
    }
    refundSubmit = (e, callback) => {
        e.preventDefault();
        let refundObj = Object.assign({}, this.state.refundModalObject);
        refundObj.studentWiseRefundTransactions.map(stud => {
            if ((stud.transactionAmount || 0) == 0.00) {
                _addNotificationError("Please enter the refund amount.", this);
                callback(true);
                return false;
            }
            if (parseFloat(stud.transactionAmount) > stud.balAmt) {
                _addNotificationWarning("Refund amount should be less than or equal to available balance.", this);
                callback(true);
                return false;
            }
        })
        if ((refundObj.reasonForRefund.trim() || '') === '') {
            _addNotificationError("Please give reason for refund.", this);
            callback(true);
            return false;
        }
        let refundTransferObj = {
            mealSchoolId: sessionStorage.getItem('SchoolId'),
            transactionType: "Refund",
            purchaseItemType: "Refund",
            transactionDescription: refundObj.reasonForRefund,
            checkNumb: "",
            totalTransactionAmount: refundObj.studentWiseRefundTransactions[0].transactionAmount,
            studentWiseTransactions: refundObj.studentWiseRefundTransactions
        }
        let headers = {
            'Content-Type': 'application/json'
        };
        postWithHeaders("/transactions/refundAmount?access_token=", JSON.stringify(refundTransferObj), headers).then((response) => {
            if (response.status === 200) {
                this.setState({ loading: false })
                _addNotification('Amount Refunded successfully.', this);
                callback(true);
                this.closeRefundModel();
            } else if (!response.ok) {
                throw Error(response.statusText);
            }
        }).catch(
            (error) => {
                _addNotificationError('Failed to refund amount ! Try again.', this);
                callback(true);
                console.log('Send Notification Error', error);
            }
        );
    }
    render() {
        gradeList = getSchoolGrades();
        const { toggleSelection, toggleAll, isSelected } = this;
        const { data, selectAll } = this.state;
        const checkboxProps = {
            selectAll,
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };
        {
            $('#all button').click(function () {
                $(this).addClass('active').siblings().removeClass('active');
                // TODO: insert whatever you want to do with $(this) here
            })
        }
        {
            $('#negativeBal button').click(function () {
                $(this).addClass('active').siblings().removeClass('active');
                // TODO: insert whatever you want to do with $(this) here
            })
        }
        try {

            $("#selector>button.active").removeClass("active");
            document.getElementById(this.state.action).classList.add("active")
        } catch (error) {
        }

        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <section className=" full-width clearfix">
                    <div className="container">
                        <div className='sweet-loading'
                            style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                            <BeatLoader
                                size={20}
                                color={'#ea7066'}
                                loading={this.state.loading}
                            />
                        </div>

                        <div className="sectionTitle col-md-12">
                            <h2>
                                <span>Manage Payments Info for: {sessionStorage.getItem('schoolYear')}</span>
                                <div id="selector"
                                    className="btn-group pull-right"
                                    style={{ margin: '5px' }}>
                                    <button type="button"
                                        className="btn btn-xs btn-inactive-color active"
                                        id="all"
                                        style={{
                                            margin: 0,
                                            marginLeft: 3,
                                            fontSize: 12
                                        }}
                                        onClick={(e) => {

                                            this.setState({
                                                selectAll: false,
                                                action: 'all',
                                                selection: [],
                                                //selectionStuList:{}
                                                // gradeName: this.state.tabIndex
                                            }, this.getDataByGrade(this.state.currentGrade, 'all', this.state.schoolYear))
                                        }}
                                    >All
                                    </button>
                                    <button type="button"
                                        className="btn btn-xs btn-inactive-color"
                                        id="negativeBal"
                                        name="negativeBal"
                                        style={{
                                            margin: 0,
                                            marginLeft: 3,
                                            fontSize: 12
                                        }}
                                        onClick={() => {
                                            // this.getFilteredData(this.state.tabIndex, 'invited');
                                            this.setState({
                                                selectAll: false,
                                                action: 'negativeBal',
                                                selection: [],
                                                selectionStuList: {}
                                            }, this.getDataByGrade(this.state.currentGrade, 'negativeBal', this.state.schoolYear))
                                        }}
                                    >Negative Balance
                                    </button></div>
                            </h2>
                        </div>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="table-responsive">
                                <section className="full-width clearfix">
                                    <div className="tab-content">
                                        <div className="media">
                                            <div className="panel panel-primary">
                                                <div className="panel-body">
                                                    <div>
                                                        <Tabs selectedIndex={this.state.gradeIndex}>
                                                            <TabList>
                                                                {gradeList.map((item, idx) => {
                                                                    return <Tab onClick={() => {
                                                                        this.state.tabIndex = item.value;
                                                                        this.setState({
                                                                            selectAll: false,
                                                                            currentGrade: (item.value),
                                                                            gradeIndex: (idx)
                                                                            // tabIndex:_tabIndex 
                                                                        },
                                                                            () => {
                                                                                this.getDataByGrade(item.value, this.state.action, this.state.schoolYear);
                                                                            })
                                                                    }}> {item.label}</Tab>
                                                                }, this)}
                                                            </TabList>
                                                            <TabPanel>
                                                                <div className="row">
                                                                    <div className="col-xs-6 pull-left">
                                                                        <input type="text" id="search"
                                                                            className="search form-control"
                                                                            style={{
                                                                                float: 'left',
                                                                                margin: '5px 0'
                                                                            }}
                                                                            name="search"
                                                                            placeholder="Search.."
                                                                            onKeyUp={this.filterSchool} />
                                                                    </div>
                                                                    <div className="col-xs-6 pull-right button-group-section">
                                                                        <button
                                                                            className="btn btn-warning button-xs pull-right"

                                                                            onClick={() => this.addPayment('multiple')}
                                                                            style={{
                                                                                float: 'right',
                                                                                margin: '5px'
                                                                            }}>
                                                                            <i className="fa fa-money"></i> Add
                                                                            Payment
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                <CheckboxTable
                                                                    ref={r => (this.checkboxTable = r)}
                                                                    data={this.state.data}
                                                                    columns={this.state.columns}
                                                                    defaultPageSize={10}
                                                                    className="-striped -highlight"
                                                                    {...checkboxProps}
                                                                />
                                                            </TabPanel>

                                                            {gradeList.map(function (key) {
                                                                return (
                                                                    <TabPanel>
                                                                        <div className="row">
                                                                            <div className="col-xs-6 pull-left">
                                                                                <input type="text" id="search"
                                                                                    className="search form-control"
                                                                                    style={{
                                                                                        float: 'left',
                                                                                        margin: '5px 0'
                                                                                    }}
                                                                                    name="search"
                                                                                    placeholder="Search.."
                                                                                    onKeyUp={this.filterSchool} />
                                                                            </div>
                                                                            <div className="col-xs-6 pull-right button-group-section">
                                                                                <button
                                                                                    className="btn btn-warning button-xs pull-right"

                                                                                    onClick={() => this.addPayment('multiple')}
                                                                                    style={{
                                                                                        float: 'right',
                                                                                        margin: '5px'
                                                                                    }}>
                                                                                    <i className="fa fa-money"></i> Add Payment
                                                                                </button>
                                                                            </div>

                                                                        </div>
                                                                        <CheckboxTable
                                                                            ref={r => (this.checkboxTable = r)}
                                                                            data={this.state.data}
                                                                            columns={this.state.columns}
                                                                            defaultPageSize={10}
                                                                            className="-striped -highlight"
                                                                            {...checkboxProps}
                                                                        />
                                                                    </TabPanel>)
                                                            }, this)}
                                                        </Tabs>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </section>
                <Modal isOpen={this.state.adjustPayment.adjustPayModalIsOpen} style={adjustPayModalStyles}>
                    <div className="modal-header row">
                        <h4 className="modal-title modal-title-color col-md-10" id="deleteLabel">Adjust Payment</h4>
                        <div className="col-md-2"><button type="button" className="pull-right btn-danger" onClick={() => {
                            this.closePaymentAdjustModel();
                        }}>X</button></div>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <div className="row">
                                    <div className="col-md-12 col-sm-12">
                                        <h4 className="color-3">{this.state.adjustPayment.adjustPaymentObj.studentName}</h4>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 col-sm-6">
                                        <label>Balance Amount:</label>
                                    </div>
                                    <div className="col-md-6 col-sm-6">
                                        <span>{currency_symbol() + ' ' + this.state.adjustPayment.adjustPaymentObj.balAmount}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 col-sm-6">
                                        <label>Adjustment Type:</label>
                                    </div>
                                    <div className="col-md-6 col-sm-6">
                                        <div>
                                            <label className='custom-label' style={{ lineHeight: '15px', paddingBottom: '7px', verticalAlign: 'middle', paddingRight: '10px', color: (this.state.adjustPayment.isDebit) ? 'rgb(234, 112, 102)' : '#757576' }}>Debit</label>
                                            <Toggle
                                                checked={(!this.state.adjustPayment.isDebit) ? false : this.state.adjustPayment.isDebit}
                                                icons={{
                                                    checked: <i className='fa fa-check' style={{ fontSize: '13px' }} />,
                                                    unchecked: <i className='fa fa-check' style={{ fontSize: '13px' }} />,
                                                }}
                                                className='custom-Toggle-color'
                                                onChange={(e) => {
                                                    let _adjustPayment = this.state.adjustPayment
                                                    _adjustPayment.isDebit = e.target.checked
                                                    this.setState({ adjustPayment: _adjustPayment });
                                                }} />
                                            <label className='custom-label' style={{ lineHeight: '15px', paddingBottom: '7px', verticalAlign: 'middle', paddingLeft: '10px', color: (!this.state.adjustPayment.isDebit) ? '#5cb85c' : '#757576' }}>Credit</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6 col-sm-6">
                                        <label style={{ paddingTop: '6px' }}>Adjust Amount: </label>
                                    </div>
                                    <div className="col-md-6 col-sm-6">
                                        <input type="text" className="form-control"
                                            value={this.state.adjustPayment.adjustPaymentObj.adjustAmount}
                                            onKeyUp={(e) => { allowNumericWithdecimal(e) }}
                                            onChange={(e) => {
                                                let _adjustPayment = this.state.adjustPayment;
                                                _adjustPayment.adjustPaymentObj.adjustAmount = (e.target.value)
                                                this.setState({ adjustPayment: _adjustPayment })
                                            }} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-112 col-sm-12">
                                        <label>Adjustment Note :</label>
                                        <textarea className="form-control" rows={5}
                                            value={this.state.adjustPayment.adjustPaymentObj.reason} onChange={(e) => {
                                                let _adjustPayment = this.state.adjustPayment;
                                                _adjustPayment.adjustPaymentObj.reason = (e.target.value)
                                                this.setState({ adjustPayment: _adjustPayment })
                                            }} ></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="text-right" style={{ paddingTop: '15px' }}>
                                    <button type="button" className="btn btn-danger btn-xs"
                                        style={{ margin: '0 0 0 5px' }} onClick={() => {
                                            this.closePaymentAdjustModel();
                                        }}
                                    ><i className="fa fa-times-circle"></i> Cancel
                                    </button>

                                    <CustomSubmit id="paymentAdjustment"
                                        type="button" className="btn btn-success btn-xs"
                                        style={{ margin: '0 0 0 5px' }}
                                        handleSubmit={(e, callback) => {
                                            let _self = this;
                                            let transObject = {
                                                "mealSchoolId": 0,
                                                "transactionType": "Adjustment",
                                                "purchaseItemType": "AdjustmentDR",
                                                "paymentType": "AdjustmentCR",
                                                "transactionDescription": "",
                                                "checkNumb": "",
                                                "totalTransactionAmount": 0,
                                                "studentWiseTransactions": [
                                                    {
                                                        "studentRecId": 0,
                                                        "name": "",
                                                        "transactionAmount": 0
                                                    }
                                                ]
                                            };
                                            let amount = this.state.adjustPayment.adjustPaymentObj.adjustAmount || ''
                                            if ((amount === '' ? 0 : parseFloat(amount)) === 0) {
                                                _addNotificationError("Please provide adjustment amount.", this);
                                                return false;
                                            }
                                            if (this.state.adjustPayment.adjustPaymentObj.reason.trim() === '') {
                                                _addNotificationError("Please provide reason for adjustment payments.", this);
                                                return false;
                                            }
                                            transObject.mealSchoolId = sessionStorage.getItem('SchoolId')
                                            transObject.transactionDescription = this.state.adjustPayment.adjustPaymentObj.reason;
                                            transObject.totalTransactionAmount = this.state.adjustPayment.adjustPaymentObj.adjustAmount || 0;
                                            if (this.state.adjustPayment.isDebit == true) {
                                                this.state.adjustPayment.adjustPaymentObj.purchaseItemType = 'AdjustmentDR'
                                                transObject.totalTransactionAmount = this.state.adjustPayment.adjustPaymentObj.adjustAmount || 0;
                                                transObject.paymentType = undefined
                                            } else {
                                                this.state.adjustPayment.adjustPaymentObj.payType = 'AdjustmentCR'
                                                transObject.purchaseItemType = undefined
                                            }
                                            transObject.studentWiseTransactions[0].transactionAmount = transObject.totalTransactionAmount;
                                            transObject.studentWiseTransactions[0].name = this.state.adjustPayment.adjustPaymentObj.studentName;
                                            transObject.studentWiseTransactions[0].studentRecId = this.state.adjustPayment.adjustPaymentObj.studentRecId;
                                            let headers = {
                                                'Content-Type': 'application/json'
                                            };
                                            _self.setState({ loading: true })
                                            postWithHeaders('/transactions/adjustBalance?access_token=', JSON.stringify(transObject), headers)
                                                .then(
                                                    (response) => {
                                                        if (!response.ok) {
                                                            throw Error(response.statusText);
                                                        }
                                                        return response.json();
                                                    }).then((response) => {
                                                        if (response.statusCode === 200) {
                                                            _self.setState({ loading: false })
                                                            _addNotification(response.statusMessage, _self);
                                                            _self.getDataByGrade(typeof _self.state.currentGrade === "number" && _self.state.currentGrade != 0 ? converter.toWords(_self.state.currentGrade) : _self.state.currentGrade, _self.state.action, _self.state.schoolYear);
                                                            _self.closePaymentAdjustModel();
                                                        } else if (!response.ok) {
                                                            throw Error(response.statusText);
                                                        }
                                                        callback(true);
                                                    }).catch(
                                                        (error) => {
                                                            _self.setState({ loading: false })
                                                            _addNotificationError(error.message, _self);
                                                            console.log('Send Notification Error', error.message);
                                                            callback(true);
                                                        });
                                        }} >
                                        <i className="glyphicon glyphicon-ok"></i> Submit</CustomSubmit>

                                </div>
                            </div></div>
                    </div>

                </Modal>
                <Modal isOpen={this.state.payModalIsOpen} style={modalStyles} >
                    <div className="modal-header row">
                        <h4 className="modal-title modal-title-color col-md-6" id="deleteLabel">Add Payments</h4>
                        <div className="col-md-6"><button type="button" className="pull-right btn-danger" onClick={() => this.closePaymentModel()}>X</button></div>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12">
                                <form name="frmPay" className="">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-12 col-md-12">
                                            <div className="form-group col-xs-3 col-sm-3 col-md-3">
                                                <label htmlFor="payType">Payment Type</label>
                                                <select className="form-control" name="payType" value={this.state.payModalObject.paymentType} onChange={
                                                    (e) => {
                                                        let payObj = this.state.payModalObject;
                                                        payObj.paymentType = e.target.value;
                                                        this.setState({ payModalObject: payObj })
                                                    }
                                                } >
                                                    <option value='Cash'>Cash</option>
                                                    <option value='Check'>Check</option>
                                                    <option value='CreditCard'>Credit card</option>
                                                </select>
                                            </div>
                                            {(this.state.payModalObject.paymentType != 'Cash') ?
                                                (<div className="form-group col-xs-3 col-sm-3 col-md-3">
                                                    <label htmlFor="checkNumb">{this.state.payModalObject.paymentType === 'Check' ? 'Check No' : 'Transaction No '}</label>
                                                    <input type="text" className="form-control" name="checkNumb" value={this.state.payModalObject.checkNumb}
                                                        onChange={(e) => {
                                                            let payObj = this.state.payModalObject;
                                                            payObj.checkNumb = e.target.value;
                                                            this.setState({ payModalObject: payObj })
                                                        }} />
                                                </div>

                                                ) : null}
                                            <div className="form-group col-xs-3 col-sm-3 col-md-3">
                                                <label htmlFor="amount">Amount</label>
                                                <div className="input-group">
                                                    <span className="input-group-addon" id="basic-addon1">{currency_symbol()}</span>
                                                    <input type="text" className="form-control" onKeyPress={(e) => { allowNumericWithdecimal(e) }} onKeyUp={(e) => { allowNumericWithdecimal(e) }} onBlur={(e) => { allowNumericWithdecimal(e) }}
                                                        name="amount" value={this.state.payModalObject.totalTransactionAmount}
                                                        placeholder="Amount" onChange={(e) => {
                                                            let payObj = this.state.payModalObject;
                                                            payObj.totalTransactionAmount = e.target.value;
                                                            if (payObj.studentWiseTransactions.length === 1) {
                                                                payObj.studentWiseTransactions[0].transactionAmount = payObj.totalTransactionAmount
                                                            }
                                                            else {
                                                                if (this.state.isEqualDistSelected) {
                                                                    this.equalDistribute(convertTwoDecimalPoint(payObj.totalTransactionAmount));
                                                                }
                                                            }
                                                            this.setState({ payModalObject: payObj });
                                                        }} />
                                                </div>

                                            </div>

                                            {this.state.payModalObject.studentWiseTransactions.length > 1 ?
                                                <div className="form-group col-xs-3 col-sm-3 col-md-3">

                                                    <label>Equally distribute</label>
                                                    <div> <button type="button" className="btn-social btn-facebook btn-square" style={{ width: '34px', height: '34px' }} onClick={(e) => {
                                                        let payObj = this.state.payModalObject;
                                                        if (e.currentTarget.classList.contains('btn-facebook-filled')) {
                                                            e.currentTarget.childNodes[0].className = "fa fa-square-o";
                                                            this.setState({ isEqualDistSelected: false })
                                                        } else {
                                                            e.currentTarget.childNodes[0].className = "fa fa-check-square-o";
                                                            let amount = payObj.totalTransactionAmount;
                                                            this.equalDistribute(amount);
                                                            this.setState({ isEqualDistSelected: true })
                                                        }
                                                        e.currentTarget.classList.toggle('btn-facebook-filled');
                                                    }} >
                                                        <i className="fa fa-square-o" ></i>
                                                    </button></div>
                                                </div> : null
                                            }
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-12 col-md-12">
                                            <table className="table table-payment-modal">
                                                <thead>
                                                    <tr>
                                                        <td>Name</td>
                                                        <td>Available Bal</td>
                                                        <td>Amount</td>
                                                    </tr>
                                                </thead>
                                                <tbody style={{ maxHeight: '300px', overflowY: 'auto', display: 'block' }}>
                                                    {
                                                        this.state.payModalObject.studentWiseTransactions.map((row, key) => {
                                                            return (<tr>
                                                                <td>{row.name}</td>
                                                                <td>{currency_symbol() + ' ' + convertTwoDecimalPoint(row.balAmt)}</td>
                                                                <td>
                                                                    <div className="input-group">
                                                                        <span className="input-group-addon" id="basic-addon1">{currency_symbol()}</span>
                                                                        <input type="text"
                                                                            disabled={this.state.payModalObject.studentWiseTransactions.length === 1 || this.state.isEqualDistSelected === true}
                                                                            className="form-control" data-id={key} name="amount" value={row.transactionAmount} onKeyPress={(e) => { allowNumericWithdecimal(e) }} onKeyUp={(e) => { allowNumericWithdecimal(e) }} onBlur={(e) => { allowNumericWithdecimal(e) }}
                                                                            onChange={(e) => {
                                                                                let payModel = this.state.payModalObject;
                                                                                payModel.studentWiseTransactions[e.target.getAttribute('data-id')].transactionAmount = (e.target.value === '' ? 0.00 : e.target.value);
                                                                                payModel.totalTransactionAmount = parseFloat((_.sum(_.map(payModel.studentWiseTransactions, d => parseFloat(d.transactionAmount)))).toFixed(2))
                                                                                this.setState({ payModalObject: payModel });
                                                                            }}
                                                                            placeholder="Amount" />
                                                                    </div></td>
                                                            </tr>)

                                                        })
                                                    }

                                                </tbody>
                                                <tfoot><tr>
                                                    <td></td>
                                                    <td>Total Amount :</td>
                                                    <td>{currency_symbol() + ' ' + convertTwoDecimalPoint(this.computAmount())}</td></tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>

                                    <div className="text-right">
                                        <button type="button" className="btn btn-danger btn-xs"
                                            onClick={() => this.closePaymentModel()}>
                                            <i className="fa fa-times-circle"
                                                style={{ margin: '0 0 0 5px' }}></i> Cancel
                                        </button>
                                        <CustomSubmit id="paySubmit" type="button" className="btn btn-success btn-xs"
                                            style={{
                                                margin: '0'
                                            }}
                                            handleSubmit={(e, callback) => this.openEmailSelect(e, callback)}
                                        >
                                            <i className="glyphicon glyphicon-ok"></i> Submit</CustomSubmit>

                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </Modal>
                <EmailSelect
                    open={this.state.showEmailSelect}
                    title={'Select Email to Send Payment Receipt'}
                    emailList={this.state.emailList}
                    onSelectionChange={(idx, type, isSelected) => {
                        let _emails = this.state.emailList;
                        if (type == 'A') {
                            _emails.forEach((itm, i) => {
                                _emails[i].selected = isSelected;
                            })
                        } else {
                            _emails[idx].selected = isSelected;
                        }
                        this.setState({ emailList: _emails })
                    }}
                    onSubmit={(e) => {
                        if (!this.state.emailList.some(item => item.selected)) {
                            _addNotificationError("Please select at least once email id.", this);
                            return false;
                        }
                        this.paymentSubmit(e)
                    }}
                    onCancel={(e) => {
                        this.closeEmailSelect()
                    }} />
                <Modal isOpen={this.state.transferModalIsOpen} style={modalStyles} >
                    <div className="modal-header row">
                        <h4 className="modal-title modal-title-color col-md-6" id="deleteLabel">Payment Transfer</h4>
                        <div className="col-md-6"><button type="button" className="pull-right btn-danger" onClick={() => this.closePaymentTrnaferModel()}>X</button></div>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12">
                                <form name="frmPay" className="">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-12 col-md-12">
                                            <h5 className="color-6 h5-transfer-border">Transfer Source Account Details:</h5>
                                            <table className="table table-payment-modal" style={{ marginBottom: '0px' }}>
                                                <thead><tr>
                                                    <td>Name</td>
                                                    <td>Available Bal</td>
                                                    <td>Amount</td></tr>
                                                </thead>
                                                <tbody style={{ maxHeight: '200px', overflowY: 'auto', display: 'block' }}>
                                                    <tr>
                                                        <td>{this.state.primaryStudentData.firstName} {this.state.primaryStudentData.lastName}</td>
                                                        <td>{currency_symbol() + ' ' + convertTwoDecimalPoint(this.state.primaryStudentData.accBalance)}</td>
                                                        <td>
                                                            <div className="input-group">
                                                                <span className="input-group-addon">{currency_symbol()}</span>
                                                                <input type="text"
                                                                    disabled=""
                                                                    className="form-control" name="amount" value={this.state.payTransferModalObject.totalTransactionAmount}
                                                                    onKeyPress={(e) => { allowNumberWithDecimalNegative(e) }}
                                                                    onKeyUp={(e) => { allowNumberWithDecimalNegative(e) }}
                                                                    onBlur={(e) => { allowNumberWithDecimalNegative(e) }}
                                                                    placeholder="Amount" onChange={(e) => {
                                                                        let payObj = this.state.payTransferModalObject;

                                                                        if (e.target.value > this.state.primaryStudentData.accBalance) {
                                                                            _addNotificationError("Insufficient amount.", this);
                                                                            return false;
                                                                        }
                                                                        payObj.totalTransactionAmount = e.target.value;
                                                                        if (payObj.studentWiseTransactions.length === 1) {
                                                                            payObj.studentWiseTransactions[0].transactionAmount = payObj.totalTransactionAmount
                                                                        }
                                                                        else {
                                                                            if (this.state.isTransEqualDistSelected) {
                                                                                this.equalTransferDistribute(convertTwoDecimalPoint(payObj.totalTransactionAmount));
                                                                            }
                                                                        }
                                                                        this.setState({ payTransferModalObject: payObj })
                                                                    }} />
                                                            </div></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <h5 className="color-6 h5-transfer-border">Transfer Target Account Details:</h5>

                                            <div className="row">
                                                <div className="col-xs-12 col-sm-12 col-md-12">
                                                    {
                                                        this.state.payTransferModalObject.studentWiseTransactions.length > 1 ?
                                                            <div className="col-xs-4" style={{ padding: '0px' }}>
                                                                <label style={{ margin: '0px 20px 0px 4px' }}>Equally distribute</label>
                                                                <span><button type="button" className="btn-social btn-facebook btn-square" style={{ width: '34px', height: '34px' }} onClick={(e) => {
                                                                    let payObj = this.state.payTransferModalObject;
                                                                    if (e.currentTarget.classList.contains('btn-facebook-filled')) {
                                                                        e.currentTarget.childNodes[0].className = "fa fa-square-o";
                                                                        this.setState({ isTransEqualDistSelected: false })
                                                                    } else {
                                                                        e.currentTarget.childNodes[0].className = "fa fa-check-square-o";
                                                                        let amount = payObj.totalTransactionAmount;
                                                                        this.equalTransferDistribute(amount);
                                                                        this.setState({ isTransEqualDistSelected: true })
                                                                    }
                                                                    e.currentTarget.classList.toggle('btn-facebook-filled');
                                                                }} >
                                                                    <i className="fa fa-square-o" ></i>
                                                                </button></span>
                                                            </div> : null
                                                    }

                                                    <div className="col-xs-4" style={{ padding: '0px' }}>
                                                        <div className="input-group">
                                                            <span className="input-group-addon">{currency_symbol()}</span>
                                                            <input type="text" className="form-control"
                                                                onKeyPress={(e) => { allowNumberWithDecimalNegative(e) }}
                                                                onKeyUp={(e) => { allowNumberWithDecimalNegative(e) }}
                                                                onBlur={(e) => { allowNumberWithDecimalNegative(e) }}
                                                                name="amount" value={this.state.payTransferModalObject.totalTransactionAmount}
                                                                placeholder="Amount" onChange={(e) => {
                                                                    let payObj = this.state.payTransferModalObject;

                                                                    if (e.target.value > this.state.primaryStudentData.accBalance) {
                                                                        _addNotificationError("Insufficient amount.", this);
                                                                        return false;
                                                                    }
                                                                    payObj.totalTransactionAmount = e.target.value;
                                                                    if (payObj.studentWiseTransactions.length === 1) {
                                                                        payObj.studentWiseTransactions[0].transactionAmount = payObj.totalTransactionAmount
                                                                    }
                                                                    else {
                                                                        if (this.state.isTransEqualDistSelected) {
                                                                            this.equalTransferDistribute(parseFloat(payObj.totalTransactionAmount));
                                                                        }
                                                                    }
                                                                    this.setState({ payTransferModalObject: payObj })
                                                                }} />
                                                        </div>
                                                    </div>

                                                    <table className="table table-payment-modal">
                                                        <thead><tr>
                                                            <td>Name</td>
                                                            <td>Available Bal</td>
                                                            <td>Amount</td></tr>
                                                        </thead>
                                                        <tbody style={{ maxHeight: '200px', overflowY: 'auto', display: 'block' }}>
                                                            {
                                                                this.state.payTransferModalObject.studentWiseTransactions.map((row, key) => {
                                                                    return (<tr>
                                                                        <td>{row.name}</td>
                                                                        <td>{currency_symbol() + ' ' + convertTwoDecimalPoint(row.balAmt)}</td>
                                                                        <td>
                                                                            <div className="input-group">
                                                                                <span className="input-group-addon" id="basic-addon1">{currency_symbol()}</span>
                                                                                <input type="text"
                                                                                    disabled={this.state.payTransferModalObject.studentWiseTransactions.length === 1 || this.state.isTransEqualDistSelected === true}
                                                                                    className="form-control" data-id={key} name="amount" value={row.transactionAmount} onKeyPress={(e) => { allowNumericWithdecimal(e) }} onKeyUp={(e) => { allowNumericWithdecimal(e) }} onBlur={(e) => { allowNumericWithdecimal(e) }}
                                                                                    onChange={(e) => {
                                                                                        let payModel = this.state.payTransferModalObject;
                                                                                        if (e.target.value > this.state.primaryStudentData.accBalance) {
                                                                                            _addNotificationError("Insufficient amount.", this);
                                                                                            return false;
                                                                                        }
                                                                                        payModel.studentWiseTransactions[e.target.getAttribute('data-id')].transactionAmount = (e.target.value === '' ? 0.00 : e.target.value);
                                                                                        payModel.totalTransactionAmount = parseFloat((_.sum(_.map(payModel.studentWiseTransactions, d => parseFloat(d.transactionAmount)))).toFixed(2))
                                                                                        this.setState({ payModalObject: payModel });
                                                                                    }}
                                                                                    placeholder="Amount" />
                                                                            </div></td>
                                                                    </tr>)

                                                                })
                                                            }
                                                        </tbody>
                                                        <tfoot><tr>
                                                            <td></td>
                                                            <td>Total Amount :</td>
                                                            <td>{currency_symbol() + ' ' + this.computTransferAmount()}</td></tr>
                                                        </tfoot>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-right">
                                        <button type="button" className="btn btn-danger btn-xs"
                                            onClick={() => this.closePaymentTrnaferModel()}>
                                            <i className="fa fa-times-circle"
                                                style={{ margin: '0 0 0 5px' }}></i> Cancel
                                        </button>
                                        <CustomSubmit id="payTrans" type="button" className="btn btn-success btn-xs"
                                            style={{
                                                margin: '0'
                                            }}
                                            handleSubmit={(e, callback) => this.paymentTransferSubmit(e, callback)}
                                        >
                                            <i className="glyphicon glyphicon-ok"></i> Submit</CustomSubmit>

                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={this.state.refundModalIsOpen} style={modalStyles} >
                    <div className="modal-header row">
                        <h4 className="modal-title modal-title-color col-md-6" id="deleteLabel">Refund Amount</h4>
                        <div className="col-md-6"><button type="button" className="pull-right btn-danger" onClick={() => this.closeRefundModel()}>X</button></div>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12">
                                <table className="table table-payment-modal">
                                    <thead>
                                        <tr>
                                            <td>Name</td>
                                            <td>Available Bal</td>
                                            <td>Refund Amount*</td>
                                        </tr>
                                    </thead>
                                    <tbody style={{ maxHeight: '300px', overflowY: 'auto', display: 'block' }}>
                                        {
                                            this.state.refundModalObject.studentWiseRefundTransactions.map((row, key) => {
                                                return (<tr>
                                                    <td>{row.name}</td>
                                                    <td>{currency_symbol() + ' ' + convertTwoDecimalPoint(row.balAmt)}</td>
                                                    <td>
                                                        <div className="input-group">
                                                            <span className="input-group-addon" id="basic-addon1">{currency_symbol()}</span>
                                                            <input type="text"
                                                                className="form-control" data-id={key} name="amount" value={row.transactionAmount} onKeyPress={(e) => { allowNumericWithdecimal(e) }} onKeyUp={(e) => { allowNumericWithdecimal(e) }} onBlur={(e) => { allowNumericWithdecimal(e) }}
                                                                onChange={(e) => {
                                                                    let refundModel = this.state.refundModalObject;
                                                                    refundModel.studentWiseRefundTransactions[e.target.getAttribute('data-id')].transactionAmount = (e.target.value === '' ? 0.00 : e.target.value);
                                                                    this.setState({ refundModalObject: refundModel });
                                                                }}
                                                                placeholder="Amount" />
                                                        </div></td>
                                                </tr>)

                                            })
                                        }

                                    </tbody>
                                </table>
                            </div>
                            <div className="form-group col-xs-6s col-sm-6 col-md-6">
                                <label htmlFor="amount">Reason for refund*</label>
                                <input type="text" className="form-control" name="reason"
                                    value={this.state.refundModalObject.reasonForRefund} onChange={(e) => {
                                        let refundModel = this.state.refundModalObject;
                                        refundModel.reasonForRefund = e.target.value;
                                        this.setState({ refundModalObject: refundModel });
                                    }} />


                            </div>

                        </div>

                        <div className="text-right">
                            <button type="button" className="btn btn-danger btn-xs"
                                onClick={() => this.closeRefundModel()}>
                                <i className="fa fa-times-circle"
                                    style={{ margin: '0 0 0 5px' }}></i> Cancel
                            </button>
                            <CustomSubmit id="refundSubmit" type="button" className="btn btn-success btn-xs"
                                style={{
                                    margin: '0'
                                }}
                                handleSubmit={(e, callback) => this.refundSubmit(e, callback)}
                            >
                                <i className="glyphicon glyphicon-ok"></i> Submit</CustomSubmit>

                        </div>
                    </div>
                </Modal>
                <Modal isOpen={this.state.alertModalIsOpen} style={alertStyle} >
                    <div className="modal-header row">
                        <h4 className="modal-title modal-title-color col-md-6" id="deleteLabel">Alert</h4>
                        <div className="col-md-6"><button type="button" className="pull-right btn-danger" onClick={() => { this.setState({ alertModalIsOpen: false }) }}>X</button></div>
                    </div>
                    <div className="modal-body">
                        <p>No sibling available to transfer the balance.</p>

                    </div>
                    <div className="text-right">
                        <button type="button" className="btn btn-success btn-xs"
                            onClick={() => {
                                this.setState({ alertModalIsOpen: false })
                            }}
                            id="deleteConfirm"><i className="fa fa-check-circle" style={{ margin: '0 0 0 5px' }} ></i> Ok
                        </button>
                    </div>

                </Modal>
                <Modal isOpen={this.state.alertRefundModalIsOpen} style={alertStyle} >
                    <div className="modal-header row">
                        <h4 className="modal-title modal-title-color col-md-6" id="refundLabel">Alert</h4>
                        <div className="col-md-6"><button type="button" className="pull-right btn-danger" onClick={() => { this.setState({ alertRefundModalIsOpen: false }) }}>X</button></div>
                    </div>
                    <div className="modal-body">
                        <p>Balance should be greater than zero for refund.</p>

                    </div>
                    <div className="text-right">
                        <button type="button" className="btn btn-success btn-xs"
                            onClick={() => {
                                this.setState({ alertRefundModalIsOpen: false })
                            }}
                            id="refundConfirm"><i className="fa fa-check-circle" style={{ margin: '0 0 0 5px' }} ></i> Ok
                        </button>
                    </div>

                </Modal>
            </div>
        )
    }
}
ManagePayments.contextTypes = {
    router: PropTypes.object.isRequired
}
export default ManagePayments;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/ManagePayments/ManagePayments.jsx